import { useObserver } from './use-observer.js';

export function useHideElement({ selector, condition, onHide } = {}) {
    const { cleanup } = useObserver(() => {
        if (typeof condition === 'function' && !condition()) return;

        const el = document.querySelector(selector);
        if (el) {
            el.style.display = 'none';
            if (typeof onHide === 'function') onHide(el);
            // cleanup();
        }
    });

    return { cleanup };
}
